// export const apiUrl= process.env.REACT_APP_API_URL;
export const apiUrl = "https://danielaurenaapi.rocazit.com";
/*export const apiUrl = "http://localhost:8000";*/
export const drName = "Dr. shofat";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";
export const apiAI = "https://auvagent.fly.dev";
/*export const apiAI = "http://localhost:8000";*/
export const webhookN8N =
  "";
